import { useParceiros } from "@/hooks/useParceiros";
import { Card, CardContent } from "@/components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";

const ParceirosSection = () => {
  const { data: parceiros = [] } = useParceiros();

  if (parceiros.length === 0) return null;

  return (
    <section className="py-20 bg-muted">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Nossos Parceiros
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Empresas que caminham conosco na construção de soluções inovadoras.
          </p>
        </div>

        <Carousel
          opts={{
            loop: true,
            align: "start",
            dragFree: true,
          }}
          plugins={[
            Autoplay({
              delay: 3000,
              stopOnInteraction: false,
              stopOnMouseEnter: true,
            }),
          ]}
          className="w-full"
        >
          <CarouselContent>
            {parceiros.map((p) => {
              const Wrapper = p.site_url ? "a" : "div";
              const wrapperProps = p.site_url
                ? { href: p.site_url, target: "_blank" as const, rel: "noopener noreferrer" }
                : {};
              return (
                <CarouselItem
                  key={p.id}
                  className="basis-1/2 md:basis-1/3 lg:basis-1/5"
                >
                  <Wrapper {...wrapperProps}>
                    <Card className="h-full border-none shadow-md hover:-translate-y-1 hover:shadow-lg transition-all duration-300 group cursor-pointer">
                      <CardContent className="p-6 flex items-center justify-center min-h-[100px]">
                        <img
                          src={p.logo_url}
                          alt={`Logo ${p.nome}`}
                          loading="lazy"
                          decoding="async"
                          width={160}
                          height={80}
                          sizes="160px"
                          className="h-20 object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
                        />
                      </CardContent>
                    </Card>
                  </Wrapper>
                </CarouselItem>
              );
            })}
          </CarouselContent>
          <CarouselPrevious className="hidden md:flex -left-12" />
          <CarouselNext className="hidden md:flex -right-12" />
        </Carousel>
      </div>
    </section>
  );
};

export default ParceirosSection;
